export default __webpack_public_path__ + "static/5-3f89ded9a798e98259ffa5afdc0a58c9.jpeg";